import { Button, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { rv } from "../tokens";
import { ChevronLeftIcon, ChevronRightIcon } from "./icons";

const useStyles = makeStyles((theme) => ({
  bar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
    padding: theme.spacing(2, 0, 0),
    borderTop: `1px solid ${rv.hairline2}`,
    position: "sticky",
    bottom: 0,
    background: rv.contentBg,
    zIndex: 2,
    "@media (max-width: 760px)": {
      position: "fixed",
      left: 0,
      right: 0,
      bottom: 0,
      margin: 0,
      padding: theme.spacing(1.5, 2),
      paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)",
      background: rv.card,
      borderTop: `1px solid ${rv.hairline}`,
      boxShadow: "0 -6px 20px rgba(0,0,0,0.08)",
      zIndex: 1200,
    },
  },
  spacer: {
    flexGrow: 1,
  },
  back: {
    color: rv.green,
    borderColor: rv.green,
    borderRadius: rv.radiusInput,
    minWidth: 110,
    minHeight: 44,
    textTransform: "none",
    fontWeight: 600,
  },
  primary: {
    background: rv.gold,
    color: rv.onDark,
    minWidth: 170,
    minHeight: 44,
    borderRadius: rv.radiusInput,
    boxShadow: "none",
    textTransform: "none",
    fontWeight: 700,
    "&:hover": { background: rv.goldHover },
    "&:disabled": { background: "#D9D2C2", color: "#fff" },
  },
}));

interface Props {
  isReview: boolean;
  canBack: boolean;
  busy: boolean; // submitting OR uploading in flight
  submitting: boolean;
  confirmed: boolean;
  onBack: () => void;
  onContinue: () => void;
  onSubmit: () => void;
}

export default function ActionBar({
  isReview,
  canBack,
  busy,
  submitting,
  confirmed,
  onBack,
  onContinue,
  onSubmit,
}: Props) {
  const classes = useStyles();

  return (
    <div className={classes.bar}>
      {canBack ? (
        <Button
          variant="outlined"
          className={classes.back}
          onClick={onBack}
          startIcon={<ChevronLeftIcon size={18} />}
        >
          Back
        </Button>
      ) : (
        <span />
      )}
      <span className={classes.spacer} />
      {isReview ? (
        <Button
          variant="contained"
          className={classes.primary}
          disabled={!confirmed || busy}
          onClick={onSubmit}
          startIcon={
            submitting ? (
              <CircularProgress size={18} color="inherit" />
            ) : undefined
          }
        >
          {submitting ? "Submitting\u2026" : "Submit for review"}
        </Button>
      ) : (
        <Button
          variant="contained"
          className={classes.primary}
          disabled={busy}
          onClick={onContinue}
          endIcon={<ChevronRightIcon size={18} />}
        >
          Continue
        </Button>
      )}
    </div>
  );
}
